import { motion } from "framer-motion";
import { BENTO } from "../lib/site";

const SPARKS = [
    [30, 42, 36, 52, 44, 60],
    [18, 14, 10, 12, 7, 5],
    [40, 34, 38, 26, 30, 22],
    [55, 40, 44, 30, 22, 14],
    [60, 48, 52, 38, 30, 24],
    [22, 26, 24, 30, 28, 34],
    [12, 20, 28, 36, 48, 58],
    [8, 14, 22, 34, 48, 64],
];

const SPARK_COLORS = ["#E11D48", "#1E88F7", "#D97706", "#3977F6", "#E11D48", "#1E88F7", "#3977F6", "#1E88F7"];

const Bento = () => (
    <div className="grid gap-3 sm:grid-cols-2 md:grid-cols-3" data-testid="bento-what-vantera-sees">
        {BENTO.map((b, i) => (
            <motion.div
                key={b.tag}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-8% 0px" }}
                transition={{ duration: 0.65, delay: (i % 4) * 0.08, ease: [0.16, 1, 0.3, 1] }}
                className={`group relative overflow-hidden rounded-xl border border-ink/10 bg-white p-6 transition-all duration-300 hover:-translate-y-1 hover:border-vantera/50 ${b.span}`}
                data-testid={`bento-tile-${i}`}
            >
                <div className="flex items-start justify-between gap-4">
                    <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slategray transition-colors duration-300 group-hover:text-vantera">{b.tag}</p>
                    <svg width="72" height="26" viewBox="0 0 72 26" className="shrink-0" aria-hidden="true">
                        <motion.polyline
                            points={SPARKS[i].map((v, j) => `${j * (72 / (SPARKS[i].length - 1))},${24 - (v / 70) * 20}`).join(" ")}
                            fill="none"
                            stroke={SPARK_COLORS[i]}
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            initial={{ pathLength: 0 }}
                            whileInView={{ pathLength: 1 }}
                            viewport={{ once: true }}
                            transition={{ duration: 1.2, delay: 0.2 + i * 0.06 }}
                        />
                    </svg>
                </div>
                <p className={`mt-4 leading-relaxed text-slategray ${b.span ? "max-w-md text-[17px]" : "text-[15px]"}`}>{b.desc}</p>
            </motion.div>
        ))}
    </div>
);

export default Bento;